function MovingObject(pTarget){
	var _target = pTarget;
	setTimeout(function(){
		move();	
	}, Math.random() * 4000);
	
	
	function move(){
		
		var _screen_size = Math.min($(window).innerWidth(), $(window).innerHeight());
		var _amp_x = _screen_size / 20;
		var _amp_y = _screen_size / 10;
		var _delai_min = 2000;
		var _delai_max = 4000;

		var _xDest = Math.round((Math.random()*_amp_x) - (_amp_x /2));
		var _yDest = Math.round((Math.random()*_amp_y) - (_amp_y /2));
		
		var _delai = Math.round(_delai_min + (Math.random() * (_delai_max - _delai_min)));
		
		_target.css({
			
			"-webkit-transition":"all " + _delai + "ms ease-in-out",
			"_moz-transition":"all " + _delai + "ms ease-in-out",
			"-o-transition":"all " + _delai + "ms ease-in-out",
			transition:"all " + _delai + "ms ease-in-out",
			"-webkit-transform":"translateX("+ _xDest + "px) translateY("+_yDest+"px)",
			"_moz-transform":"translateX("+ _xDest + "px) translateY("+_yDest+"px)",
			"-o-transform":"translateX("+ _xDest + "px) translateY("+_yDest+"px)",
			transform:"translateX("+ _xDest + "px) translateY("+_yDest+"px)",
		});
		
		
		
		setTimeout(function(){
			move();
		}, _delai);
	}
}

$(window).load(function(){
	if($("[moving-object]").length){
		$("[moving-object]").each(function(){
			var _movingObj = new MovingObject($(this));
		})
	}
})